const selectors = {
    readMoreBtn: document.querySelector('[data-readMoreBtn]'),
    readMoreContainer: document.querySelector('[data-readMoreContainer]')
};
class templateCollectionJS {
    constructor() {
        this.readMore();
    }

    // Read More and Read Less
    readMore() {
        if (selectors.readMoreBtn) {
            selectors.readMoreBtn.addEventListener('click', (e) => {
                e.preventDefault();
                let currentTarget = e.target;
                let readMoreEle = selectors.readMoreContainer.querySelector('.hidden-text');
                if (readMoreEle) {
                    if (selectors.readMoreContainer.classList.contains('open')) {
                        Utility.toggleElement(selectors.readMoreContainer, 'close');
                        currentTarget.innerHTML = 'Read More'
                    } else {
                        Utility.toggleElement(selectors.readMoreContainer, 'open');
                        currentTarget.innerHTML = 'Read Less'
                    }
                }
            });
        }
    }
}

typeof templateCollectionJS !== 'undefined' && new templateCollectionJS();

document.querySelector('#main-collection-filters').style.top = document.querySelector('#shopify-section-header').offsetHeight + 18 + 'px';


document.querySelectorAll('.card .card-title .product-link').forEach((element) => {
    var titleStr = element.innerHTML;
    if (titleStr.length >= 19) {
        element.closest('.card-title').classList.add('text-overflow-fade')
    }
})

var collectionDesc = document.querySelector('[data-collection-description]');
if (collectionDesc != null) {
  if (collectionDesc.innerHTML.length > 800) {
      collectionDesc.closest('.collection-description').classList.add('data-hidden')
      document.querySelector('[data-show-more]').addEventListener('click', function () {
          collectionDesc.closest('.collection-description').classList.toggle('show-more')
      })
  }
  else {
      collectionDesc.closest('.collection-description').classList.remove('data-hidden');
  }
}


document.querySelectorAll('[data-change-month]').forEach((ele)=>{
    ele.addEventListener('click',(event)=>{
        let clickEvent = ele.getAttribute('data-change-month');
        let currentSelectedMonth = parseInt(document.querySelector('[data-month_number]:not(.d-none)')?.getAttribute('data-month_number'));
        if (clickEvent == 'previous') {
            if (currentSelectedMonth != 1) {
                currentSelectedMonth--;
            }
        }else{
            if (currentSelectedMonth != 12) {
                currentSelectedMonth++;
            }
        }
        if (currentSelectedMonth == 1) {
            document.querySelector('[data-change-month="previous"]')?.classList.add('disabled');
            
        }else{
            document.querySelector('[data-change-month="previous"]')?.classList.remove('disabled');
        }
        if (currentSelectedMonth == 12) {
            document.querySelector('[data-change-month="next"]')?.classList.add('disabled');
        }else{
            document.querySelector('[data-change-month="next"]')?.classList.remove('disabled');
        }
        
        document.querySelectorAll(`[data-month_number]:not(.d-none)`).forEach((monthEle)=>{
            monthEle.classList.add('d-none')
        });
        document.querySelectorAll(`[data-month_number="${currentSelectedMonth}"]`).forEach((monthEle)=>{
            monthEle.classList.remove('d-none')
        });
    })
})